module.exports = __webpack_public_path__ + "static/media/wizualizacja-133.e9ae32bf.png";